import { FileText, Loader2 } from "lucide-react";
import ScaledTemplatePreview from "./ScaledTemplatePreview";
import "./_draft-document-preview.scss";

/**
 * Presentational shell for a wizard's live "what will actually get sent"
 * document preview - the idle/loading/error/ready branches every consumer
 * (Proposals, Invoices, Upsells/Downsells) renders identically around
 * useDraftDocumentPreview's state. Pass `status`/`html`/`message` straight
 * from that hook; `idleMessage` is the one thing that differs per entity
 * ("Select a company and market to preview the invoice document.", etc.) -
 * shown for the hook's own "idle" status, which it holds whenever the
 * caller's required fields (company/market/...) aren't filled in yet, so
 * no separate "canPreview" prop is needed here.
 */
const DraftDocumentPreview = ({ status, html, message, idleMessage }) => {
  if (status === "idle") {
    return (
      <div className="draft-document-preview--empty">
        <FileText size={28} className="draft-document-preview__empty-icon" />
        <p>{idleMessage}</p>
      </div>
    );
  }

  if (status === "not-configured" || status === "error") {
    return (
      <div className="draft-document-preview--empty">
        <FileText size={28} className="draft-document-preview__empty-icon" />
        <p>{message}</p>
      </div>
    );
  }

  if (status === "loading" && !html) {
    return (
      <div className="draft-document-preview--empty">
        <Loader2 size={20} className="draft-document-preview__spinner" />
        <p>Rendering preview…</p>
      </div>
    );
  }

  return (
    <div className="draft-document-preview">
      {status === "refreshing" && (
        <div className="draft-document-preview__refresh-badge">
          <Loader2 size={12} className="draft-document-preview__spinner" />
          Updating…
        </div>
      )}
      <ScaledTemplatePreview srcDoc={html} orientation="portrait" />
    </div>
  );
};

export default DraftDocumentPreview;
